const footer_mobile_menu = () => {
	const children_items = document.querySelectorAll('footer.footer .is_mobile .menu-footer__list li.menu-item-has-children');

	if (children_items) {

		children_items.forEach((li) => {
			const el = li.querySelector('a');
			const button = document.createElement('button');
			button.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5C10 5.39449 9.6802 5.71429 9.28572 5.71429L0.714286 5.71429C0.319797 5.71429 1.39787e-08 5.39449 3.12223e-08 5C4.84659e-08 4.60551 0.319797 4.28571 0.714286 4.28571H9.28571Z" fill="black"/>
			<path d="M5.71429 9.28571C5.71429 9.6802 5.39449 10 5 10C4.60551 10 4.28571 9.6802 4.28571 9.28571L4.28572 0.714286C4.28572 0.319797 4.60551 2.79575e-08 5 6.24448e-08C5.39449 9.69322e-08 5.71429 0.319797 5.71429 0.714286L5.71429 9.28571Z" fill="black"/>
			</svg>`;
			button.classList.add('sub_menu_clickable');
			button.setAttribute('type', 'button');

			el.addEventListener('click', function(e) {
				e.preventDefault();

				const sub_menu = el.nextElementSibling;

				if ( sub_menu.classList.contains('active') ) {
					sub_menu.classList.remove('active');

					button.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5C10 5.39449 9.6802 5.71429 9.28572 5.71429L0.714286 5.71429C0.319797 5.71429 1.39787e-08 5.39449 3.12223e-08 5C4.84659e-08 4.60551 0.319797 4.28571 0.714286 4.28571H9.28571Z" fill="black"/>
			<path d="M5.71429 9.28571C5.71429 9.6802 5.39449 10 5 10C4.60551 10 4.28571 9.6802 4.28571 9.28571L4.28572 0.714286C4.28572 0.319797 4.60551 2.79575e-08 5 6.24448e-08C5.39449 9.69322e-08 5.71429 0.319797 5.71429 0.714286L5.71429 9.28571Z" fill="black"/>
			</svg>`;
				} else {
					sub_menu.classList.add("active");
					button.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5V5C10 5.39449 9.6802 5.71429 9.28571 5.71429L0.714286 5.71429C0.319797 5.71429 1.39787e-08 5.39449 3.12223e-08 5V5C4.84659e-08 4.60551 0.319797 4.28571 0.714286 4.28571H9.28571Z" fill="black"/>
					</svg>
					`;
				}
			});

			el.appendChild(button);
		});
	}
}

export default footer_mobile_menu();